import React from 'react';
import Title from '../partials/title';
import request from 'superagent';
import config from '../../config';
import { Animated } from 'react-animated-css';
import _ from 'lodash';

// August 16th: Refactored for responsiveness
class ContactForm extends React.Component {
    state = {
        reason: null,
        index: null,
        selectedSeason: null,
        gender: null,
        ageGroup: null,
        payload: {},
        valid: true,
        ageGroups: [
            'U06',
            'U07',
            'U08',
            'U09',
            'U10',
            'U11',
            'U12',
            'U13',
            'U14',
            'U15',
            'U16',
            'U17',
            'U18',
            'Adults',
        ]
    }
    componentWillMount() {
        const { contactActions, contactEmailList, tournaments, tournamentsActions } = this.props;
        if (!contactEmailList) this.setState({ microTransac: true }, () => {
            contactActions && contactActions.fetch();
        });
        else this.setState({ contactEmailList });
        (!tournaments || !tournaments.length) && tournamentsActions.fetch();
    }
    componentWillReceiveProps = nextProps => {
        const { contactEmailList } = nextProps;
        this.setState({ contactEmailList, microTransac: false });
    }
    onReason = index => this.setState({ reason: this.state.contactEmailList[index], index, isReasonOpen: false });
    onSelectSeason = selectedSeason => this.setState({ selectedSeason, isTournamentsOpen: false });
    onSelectGender = gender => this.setState({ gender, isGendersOpen: false });
    onSelectAgeGroup = ageGroup => this.setState({ ageGroup, isAgeGroupsOpen: false });

    toggleTournament = () => this.setState({ isTournamentsOpen: !this.state.isTournamentsOpen });
    toggleReason = () => this.setState({ isReasonOpen: !this.state.isReasonOpen });
    toggleGender = () => this.setState({ isGendersOpen: !this.state.isGendersOpen });
    toggleAgeGroup = () => this.setState({ isAgeGroupsOpen: !this.state.isAgeGroupsOpen });

    send = () => {

        // validations
        const { payload, index } = this.state;
        payload.Name = this.txtName.value;
        payload.Phone = this.txtPhone.value;
        payload.Email = this.txtEmail.value;
        payload.Reason = this.state.reason;
        payload.Message = this.taMessage.value;
        payload.Gender = this.state.gender;
        payload.TeamName = (this.txtTeamName || {}).value;
        payload.AgeGroup = this.state.ageGroup;
        payload.Season = _.pick(this.state.selectedSeason || {}, 'id', 'Name', 'SeasonName');
        payload.HostClub = this.txtHostClub ? this.txtHostClub.value : null;
        payload.HostLocation = this.txtHostLocation ? this.txtHostLocation.value : null;

        let invalid = false;

        if (!this.txtName.value) invalid = 'invalid name';
        if (!this.txtPhone.value) invalid = 'invalid phone';
        if (!this.txtEmail.value) invalid = 'invalid email';
        if (!this.state.reason) invalid = 'invalid reason';
        if (!this.taMessage.value) invalid = 'invalid message';
        if (!this.state.selectedSeason && [0, 1, 2, 4].indexOf(index) !== -1) invalid = 'invalid season';
        if ([0, 1, 3, 5].indexOf(index) !== -1 && !this.txtTeamName.value) invalid = 'invalid team name';
        if ([1, 3, 5].indexOf(index) !== -1 && !this.state.gender) invalid = 'invalid gender';
        if ([1, 3, 5].indexOf(index) !== -1 && !this.state.ageGroup) invalid = 'invalid age group';
        if ([6].indexOf(index) !== -1 && !this.txtHostClub.value) invalid = 'invalid host club';
        if ([6].indexOf(index) !== -1 && !this.txtHostLocation.value) invalid = 'invalid host location';

        this.setState({ invalid }, () => {
            if (!invalid) {
                // TODO
                request.post(`${config.apiEndpoint}/api/cs/v2/contact`)
                    .set('Authorization', `Bearer ${config.apiKey}`)
                    .send(payload)
                    .then(() => {
                        this.setState({ thanks: true, payload: {}, reason: null, selectedSeason: null, gender: null, ageGroup: null, });
                    });
                // CALL API
                // CLEAR FORM
                this.txtName.value = null;
                this.txtPhone.value = null;
                this.txtEmail.value = null;
                this.taMessage.value = null;
                (this.txtHostClub || {}).value = null;
                (this.txtHostLocation || {}).value = null;
                (this.txtTeamName || {}).value = null;
            } 
        });

    }

    render() {
        // TODO: feedback on missing fields
        const { className, tournaments } = this.props,
            { reason, contactEmailList, index, selectedSeason, gender, ageGroup, payload, ageGroups, thanks, invalid } = this.state;
        return <div className={`${className} hind w3-container w3-content d-flex row-column pt-8 pb-8`}>
            <div className="w-100">
                <Title text="WRITE US" className="white" />
                <p className="margin-top toBold">{index} We appreciate your input and we look forward to hearing from you.</p>
                <p className="margin-top">At Challenge Sports we believe that Effective Communication is an important ingredient in the success of our events.</p>
                <p className="margin-top">While most information can be found within the pages of our site (FAQs, Event Pages, etc.), if you can't find what you're looking for, or have any other questions please feel free to use the form on the right.</p>
            </div>
            <div className="vertical-gap" />
            {contactEmailList && <div className="w-100">

                <label htmlFor="name">Full Name</label>
                <input className={`${invalid && this.txtName && !this.txtName.value ? 'bg-red' : ''} white dark`} type="text" maxLength="50"
                    ref={i => this.txtName = i} defaultValue={payload.Name} />

                <label htmlFor="name" className="margin-top">Phone Number</label>
                <input className={`${invalid && this.txtPhone && !this.txtPhone.value ? 'bg-red' : ''} white dark`} type="number" maxLength="50" ref={i => this.txtPhone = i} defaultValue={payload.Phone} />

                <label htmlFor="name" className="margin-top">Email</label>
                <input className={`${invalid && this.txtEmail && !this.txtEmail.value ? 'bg-red' : ''} white dark`} type="text" maxLength="50" ref={i => this.txtEmail = i} defaultValue={payload.Email} />

                {/* Reason for Contact */}
                <label htmlFor="name" className="margin-top">Reason for Contact</label>
                <div className="btn-group block">
                    <button onClick={this.toggleReason} className={`w3-button ${invalid && !reason ? 'bg-red' : ''} dark text-left d-flex flex-row`}>{reason ? reason.Category : 'Please choose one'}<i className="fa fa-caret-down margin-left-half ml-auto"></i></button>
                    <div className={`dropdown-menu ${this.state.isReasonOpen ? 'show' : ''}`}>
                        {contactEmailList && contactEmailList.map((reason, i) => <button key={i} onClick={() => this.onReason(i)} className="w3-bar-item w3-button block w-100 text-left">{reason.Category}</button>)}
                    </div>
                </div>

                {/* Select  Tournament. TODO: add 'Other' at the end of the list */}
                {[0, 1, 2, 4].indexOf(index) !== -1 && (
                    <section>
                        <label htmlFor="name" className="margin-top">Tournament</label>
                        <div className="btn-group block">
                            <button onClick={this.toggleTournament} className={`w3-button ${invalid && !selectedSeason ? 'bg-red' : ''} dark text-left d-flex flex-row`}>{selectedSeason ? selectedSeason.Name : 'Please choose one'}<i className="fa fa-caret-down margin-left-half ml-auto"></i></button>
                            <div className={`dropdown-menu ${this.state.isTournamentsOpen ? 'show' : ''}`}>
                                {tournaments && tournaments.map((season, i) => <button key={i} onClick={() => this.onSelectSeason(season)} className="w3-bar-item w3-button block w-100 text-left">{season.Name}</button>)}
                            </div>
                        </div>
                    </section>
                )}

                {[0, 1, 3, 5].indexOf(index) !== -1 && (
                    <section>
                        <label htmlFor="name" className="margin-top">Team Name</label>
                        <input className={`${invalid && this.txtTeamName && !this.txtTeamName.value ? 'bg-red' : ''} white dark`} type="text" ref={i => this.txtTeamName = i} defaultValue={payload.TeamName} />
                    </section>
                )}

                {[0, 1, 3, 5].indexOf(index) !== -1 && (
                    <section>
                        <label htmlFor="name" className="margin-top">Gender</label>
                        <div className="btn-group block">
                            <button onClick={this.toggleGender} className={`w3-button ${invalid && !gender ? 'bg-red' : ''} dark text-left d-flex flex-row`}>{gender || 'Please choose one'}<i className="fa fa-caret-down margin-left-half ml-auto"></i></button>
                            <div className={`dropdown-menu ${this.state.isGendersOpen ? 'show' : ''}`}>
                                <button onClick={() => this.onSelectGender('Male')} className="w3-bar-item w3-button block w-100 text-left"><i className="fas fa-male margin-right-half" />Male</button>
                                <button onClick={() => this.onSelectGender('Female')} className="w3-bar-item w3-button block w-100 text-left"><i className="fas fa-female margin-right-half" />Female</button>
                            </div>
                        </div>
                    </section>
                )}

                {[0, 1, 3, 5].indexOf(index) !== -1 && (
                    <section>
                        <label htmlFor="name" className="margin-top">Age Group</label>
                        <div className="btn-group block">
                            <button onClick={this.toggleAgeGroup} className={`w3-button ${invalid && !ageGroup ? 'bg-red' : ''} dark text-left d-flex flex-row`}>{ageGroup || 'Please choose one'}<i className="fa fa-caret-down margin-left-half ml-auto"></i></button>
                            <div className={`dropdown-menu ${this.state.isAgeGroupsOpen ? 'show' : ''}`}>
                                {ageGroups && ageGroups.map((ag, i) => <button key={i} onClick={() => this.onSelectAgeGroup(ag)} className="w3-bar-item w3-button block w-100 text-left">{ag}</button>)}
                            </div>
                        </div>
                    </section>
                )}

                {[6].indexOf(index) !== -1 && (
                    <section>
                        <label htmlFor="name" className="margin-top">Host Club</label>
                        <input className={`${invalid && this.txtHostClub && !this.txtHostClub.value ? 'bg-red' : ''} white dark`} type="text" ref={i => this.txtHostClub = i} defaultValue={payload.HostClub} />
                    </section>
                )}

                {[6].indexOf(index) !== -1 && (
                    <section>
                        <label htmlFor="name" className="margin-top">Host Location</label>
                        <input className={`${invalid && this.txtHostLocation && !this.txtHostLocation.value ? 'bg-red' : ''} white dark`} type="text" ref={i => this.txtHostLocation = i} defaultValue={payload.HostLocation} />
                    </section>
                )}

                <label htmlFor="name" className="margin-top">Message</label>
                <textarea className={`${invalid && this.taMessage && !this.taMessage.value ? 'bg-red' : ''} white dark`} type="text" ref={i => this.taMessage = i} defaultValue={payload.Message} />

                <div className="d-flex flex-row margin-top-double margin-bottom">
                    <button onClick={this.send} type="button" style={{ width: 170 }} className="btn-black text-center align-self-center margin-right">SEND MESSAGE</button>
                    {invalid && <Animated animationIn="fadeInRight" className="align-self-celter ml-auto">
                        <span className="red margin-top-half">** Please complete the missing fields</span>
                    </Animated>}
                    {thanks && <Animated animationIn="fadeInRight" className="align-self-center ml-auto">
                        <span className="white margin-top-half d-flex flex-row">
                            <i className="fas fa-check green margin-right-half margin-top-half" />
                            <span className="line1">Thanks for reaching out. Will be contacting you as soon as possible.</span></span>
                    </Animated>}
                </div>
            </div>}
        </div>
    }
}

export default ContactForm;


// WEBPACK FOOTER //
// ./src/components/contact/form.js